import React from 'react'
import PropTypes from 'prop-types'

import { Skeleton, SkeletonText } from '@walmart-web/livingdesign-components'

import './index.css'

const ProductCardSkeleton = ({ className }) => (
  <div className={`product-card-skeleton__wrapper ${className}`}>
    <div>
      <div className="product-card-skeleton__content mb-3">
        <Skeleton height="150px" variant="rectangle" />
      </div>
      <div className="product-card-skeleton__content mb-3">
        <Skeleton height="30px" variant="rectangle" />
      </div>
      <div className="product-card-skeleton__content mb-3">
        <SkeletonText lines={2} />
      </div>
    </div>
    <div>
      <Skeleton height="30px" width="70%" variant="rounded" />
    </div>
  </div>
)

ProductCardSkeleton.defaultProps = {
  className: '',
}

ProductCardSkeleton.propTypes = {
  className: PropTypes.string,
}

export default ProductCardSkeleton